import React, { useState, useEffect } from 'react';
import {
  Grid,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper,
} from '@mui/material';
import { toast } from 'react-toastify';

import ReportPageSelectionTable from './reportpageselection';
import KeyPerformanceIndicatorTable from './keyperformanceindicator';
import ProjectSubTypeTable from './projectsubtype';
import ProjectTypeTable from './projecttype';
import AccountTypeTable from './accountType';
import AccountSubTypeTable from './accountsubtype';
import CashflowCategoryTable from './cashflowCategory';
import PNLTable from './PNLTable';
import BalanceSheetLayout from './BalanceSheetLayout';
import ManageReportDataApi from '../../Api/ApiManageReportData';
import appdata from '../../Services/appdata';
import './style.css';

const tableNames = [
  'Report Page Selection',
  'KeyPerformance Indicator',
  'Project SubType',
  'Project Type',
  'Account Type',
  'Account SubType',
  'Cashflow Category',
  'PNL',
  'BalanceSheetLayout',
];

function ManageReportConfig() {
  const [company, setCompany] = useState(null);
  const [selectedTableId, setSelectedTableId] = useState('');
  const [tableData, setTableData] = useState([]);

  const tableCompNames = [
    ReportPageSelectionTable,
    KeyPerformanceIndicatorTable,
    ProjectSubTypeTable,
    ProjectTypeTable,
    AccountTypeTable,
    AccountSubTypeTable,
    CashflowCategoryTable,
    PNLTable,
    BalanceSheetLayout,
  ];

  useEffect(() => {
    const asnyFn = async () => {
      const company_id = appdata.getItem('company_org_id');
      const res = await ManageReportDataApi.getCompany(company_id);
      if (res.status === 200) {
        setCompany(res.data);
      } else {
        toast.error(res.message);
      }
    }
    asnyFn();
  }, []);

  const getStateData = (data) => {
    setTableData(data);
  };

  const handleTemplateSelect = async (tableName) => {
    if (selectedTableId !== tableName) {
      setTableData([]);
      setSelectedTableId(tableName);
      await getTemplateData(tableName);
    }
  };

  const getTemplateData = async (tableName, companyId) => {
    let result = [];
    if (tableName === 'PNL') {
      if (companyId) {
        let pnl = [];
        let accountTypes = [];
        await Promise.all([
          ManageReportDataApi.getTemplate(tableName)
            .then((res) => {
              if (res.status === 200) pnl = res.data;
              else toast.error(res.message);
            })
            .catch((error) => toast.error(error.message)),
          ManageReportDataApi.getPnlAccountTypes()
            .then((pres) => {
              if (pres.status === 200) {
                accountTypes = pres.data;
              } else toast.error(pres.message);
            })
            .catch((error) => toast.error(error.message)),
        ]);
        result = [pnl, accountTypes];
      } else result = [[], []];
    } else if (tableName === 'Report Page Selection') {
      await ManageReportDataApi.getTemplate(tableName)
        .then((res) => {
          if (res.status === 200) result = res.data;
          else toast.error(res.message);
        })
        .catch((error) => toast.error(error.message));
    } else if (tableName === 'Account Type') {
      await ManageReportDataApi.getTemplate('Account Type')
        .then((pres) => {
          if (pres.status === 200) {
            if (!pres.data) {
              ManageReportDataApi.getTemplate('Account Type')
                .then((res) => {
                  if (res.status === 200) result = res.data;
                  else toast.error(res.message);
                })
                .catch((error) => toast.error(error.message));
            } else result = pres.data;
          } else toast.error(pres.message);
        })
        .catch((error) => toast.error(error.message));
    } else if (tableName === 'Account SubType') {
      await ManageReportDataApi.getTemplate('Account SubType')
        .then((pres) => {
          if (pres.status === 200) {
            if (!pres.data) {
              ManageReportDataApi.getTemplate('Account SubType')
                .then((res) => {
                  if (res.status === 200) result = res.data;
                  else toast.error(res.message);
                })
                .catch((error) => toast.error(error.message));
            } else result = pres.data;
          } else toast.error(pres.message);
        })
        .catch((error) => toast.error(error.message));
    } else if (tableName === 'Cashflow Category') {
      await ManageReportDataApi.getTemplate('Cashflow Category')
        .then((pres) => {
          if (pres.status === 200) {
            if (!pres.data) {
              ManageReportDataApi.getTemplate('Cashflow Category')
                .then((res) => {
                  if (res.status === 200) result = res.data;
                  else toast.error(res.message);
                })
                .catch((error) => toast.error(error.message));
            } else result = pres.data;
          } else toast.error(pres.message);
        })
        .catch((error) => toast.error(error.message));
    } else if (tableName === 'BalanceSheetLayout') {
      if (companyId) {
        let balancesheets = [];
        let accountTypes = [];
        let accountSubTypes = [];
        await Promise.all([
          ManageReportDataApi.getTemplate(tableName)
            .then((res) => {
              if (res.status === 200) balancesheets = res.data;
              else toast.error(res.message);
            })
            .catch((error) => toast.error(error.message)),
          ManageReportDataApi.getBsAccountTypes()
            .then((pres) => {
              if (pres.status === 200) {
                accountTypes = pres.data;
              } else toast.error(pres.message);
            })
            .catch((error) => toast.error(error.message)),
          ManageReportDataApi.getBsAccountSubTypes()
            .then((pres) => {
              if (pres.status === 200) {
                accountSubTypes = pres.data;
              } else toast.error(pres.message);
            })
            .catch((error) => toast.error(error.message)),
        ]);
        result = [balancesheets, accountTypes, accountSubTypes];
      } else result = [[], [], []];
    } else {
      await ManageReportDataApi.getTemplate(tableName)
        .then((res) => {
          if (res.status === 200) result = res.data;
          else toast.error(res.message);
        })
        .catch((error) => toast.error(error.message));
    }

    getStateData(result);
  };

  const onAddTemplate = async (tableName, type = 'manual') => {
    if (type === 'auto') {
      ManageReportDataApi.addAutoTemplate(tableName)
        .then((res) => {
          if (res.status === 200) {
            ManageReportDataApi.getTemplate(tableName)
              .then((res) => {
                if (res.status === 200) getStateData(res.data);
                else toast.error(res.message);
              })
              .catch((error) => toast.error(error.message));
          } else toast.error(res.message);
        })
        .catch((error) => toast.error(error.message));
    } else {
      ManageReportDataApi.addTemplate(tableName)
        .then((res) => {
          if (res.status === 200) {
            ManageReportDataApi.getTemplate(tableName)
              .then((res) => getStateData(res.data))
              .catch((error) => toast.error(error.message));
          } else toast.error(res.message);
        })
        .catch((error) => toast.error(error.message));
    }
  };

  const onDeleteTemplate = (tableName, rowIndex) => {
    ManageReportDataApi.deleteTemplate(tableName, rowIndex)
      .then(res => {
        if (res.status === 200) {
          ManageReportDataApi.getTemplate(tableName)
            .then((res) => getStateData(res.data))
            .catch((error) => toast.error(error.message));
        } else toast.error(res.message);
      })
      .catch((error) => toast.error(error.message));
  };
  
  return (
    <div className="ManageReportConfig">
      <Grid container spacing={1}>
        <Grid size={3}>
          <Paper style={{ marginRight: 8 }}>
            <Table aria-label="table">
              <TableHead>
                <TableRow>
                  <TableCell align="center">Name</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {tableNames.map((tableName, index) => (
                  <TableRow
                    key={index}
                    style={{
                      background:
                        selectedTableId === tableName ? 'rgba(0,0,0,0.1)' : '',
                    }}
                  >
                    <TableCell
                      component="td"
                      scope="row"
                      align="center"
                      sx={{ cursor: 'pointer' }}
                      onClick={() => handleTemplateSelect(tableName)}
                    >
                      {tableName}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Paper>
        </Grid>
        <Grid size={9} sx={{ position: 'relative' }}>
          {tableNames.map((tableName, index) => {
            var TagName = tableCompNames[index];
            return (
              tableName === selectedTableId && (
                <TagName
                  key={index}
                  name={tableName}
                  company={company}
                  rows={tableData}
                  onClickedAdd={onAddTemplate}
                  onClickedDelete={onDeleteTemplate}
                  getTemplateData={getTemplateData}
                  getStateData={getStateData}
                />
              )
            );
          })}
        </Grid>
      </Grid>
    </div>
  );
}

export default ManageReportConfig;
